export const MODEL_OPTIONS = [
  {
    value: 'gpt-5.4',
    label: 'GPT-5.4',
    provider: 'openai',
    family: 'reasoning',
    description: 'Best writing and reasoning for mastery plans, tutoring, and reviews.',
  },
  {
    value: 'gpt-realtime',
    label: 'GPT Realtime',
    provider: 'openai',
    family: 'realtime',
    description: 'Native realtime audio/text model for live tutoring and voice sessions.',
  },
  {
    value: 'grok-4.20-0309-reasoning',
    label: 'Grok 4.20 Reasoning',
    provider: 'xai',
    family: 'reasoning',
    description: 'Top Grok reasoning for long-context and multimodal source synthesis.',
  },
  {
    value: 'grok-4.20-0309-non-reasoning',
    label: 'Grok 4.20',
    provider: 'xai',
    family: 'general',
    description: 'Balanced Grok for general multimodal understanding.',
  },
  {
    value: 'grok-4-1-fast-non-reasoning',
    label: 'Grok 4.1 Fast',
    provider: 'xai',
    family: 'fast',
    description: 'Faster Grok pass for lighter tasks.',
  },
  {
    value: 'grok-4.20-multi-agent-0309',
    label: 'Grok 4.20 Multi-Agent',
    provider: 'xai',
    family: 'agentic',
    description: 'Deep long-context Grok orchestration model.',
  },
];

export const MODEL_OPTIONS_BY_ID = Object.fromEntries(MODEL_OPTIONS.map((model) => [model.value, model]));

export const TASK_MODEL_FIELDS = [
  { key: 'chat', label: 'Chat + personal assistant' },
  { key: 'mastery_planner', label: 'Mastery journey planner' },
  { key: 'pedantic_tutor', label: 'Pedantic coach pass' },
  { key: 'document_understanding', label: 'Document understanding' },
  { key: 'review_questions', label: 'Review generation' },
  { key: 'answer_evaluation', label: 'Answer evaluation' },
  { key: 'vision_reasoning', label: 'Image / slide reasoning' },
  { key: 'video_understanding', label: 'Video understanding' },
  { key: 'realtime_voice', label: 'Realtime voice' },
];

export const PREMIUM_TASK_DEFAULTS = {
  chat: 'gpt-5.4',
  mastery_planner: 'gpt-5.4',
  pedantic_tutor: 'gpt-5.4',
  document_understanding: 'gpt-5.4',
  review_questions: 'gpt-5.4',
  answer_evaluation: 'gpt-5.4',
  vision_reasoning: 'grok-4.20-0309-reasoning',
  video_understanding: 'grok-4.20-0309-reasoning',
  realtime_voice: 'gpt-realtime',
};

export const FAST_TASK_DEFAULTS = {
  chat: 'grok-4-1-fast-non-reasoning',
  mastery_planner: 'gpt-5.4',
  pedantic_tutor: 'gpt-5.4',
  document_understanding: 'grok-4-1-fast-non-reasoning',
  review_questions: 'gpt-5.4',
  answer_evaluation: 'gpt-5.4',
  vision_reasoning: 'grok-4.20-0309-non-reasoning',
  video_understanding: 'grok-4.20-0309-reasoning',
  realtime_voice: 'gpt-realtime',
};
